// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
// Mostra as novidades da versão após o usuário atualizar o aplicativo.
import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Sparkles, CheckCircle2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { CHANGELOG, APP_VERSION } from '../changelog';

const STORAGE_KEY = 'app_version_seen';

export default function WhatsNewDialog() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    const seen = localStorage.getItem(STORAGE_KEY);
    if (!seen) {
      localStorage.setItem(STORAGE_KEY, APP_VERSION);
      return;
    }
    if (seen !== APP_VERSION) setOpen(true);
  }, [user]);

  const handleClose = (v) => {
    if (!v) localStorage.setItem(STORAGE_KEY, APP_VERSION);
    setOpen(v);
  };

  const release = CHANGELOG[0];

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md" data-testid="whats-new-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-primary" /> Novidades da versão {release.version}
          </DialogTitle>
          <DialogDescription>Aplicativo atualizado — {release.date}. Veja o que mudou:</DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 max-h-72 overflow-y-auto pr-1" data-testid="whats-new-list">
          {release.items.map((item, i) => (
            <li key={i} className="flex items-start gap-2 text-sm">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
        <div className="flex justify-end">
          <Button onClick={() => handleClose(false)} data-testid="whats-new-close-btn">Entendi</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
